import React, { useEffect, useState, useRef } from "react";
import { useParams } from "react-router";
import { Container, Button, Dropdown, DropdownButton, Form, Col, Row, Spinner, Pagination as BsPagination, InputGroup } from 'react-bootstrap';
import './Pagination.scss';

const Pagination = (props) => {

    let elementsPerPage = props.elementsPerPage
    let total = props.itemsLength

    const [paginationActiveNumber, setPaginationActiveNumber] = useState(props.currentPagination ? props.currentPagination : 1)
    const [paginationComponent, setPaginationComponent] = useState(null)

    useEffect(() => {
        setPaginationActiveNumber(props.currentPagination)
    }, [props.currentPagination]);

    const PaginationPageNumbers = () => {
        let paginationItemList = []

        let lastNum = (total / elementsPerPage == Math.floor(total / elementsPerPage)) ? Math.floor(total / elementsPerPage) : Math.floor(total / elementsPerPage) + 1

        if (lastNum == 1) { // ne pas afficher de pagination si les résultats tiennent en 1 page
            return (null)
        }

        if (lastNum <= 9) { // affichage simplifié si moins de 9 pages
            for (let number = 1; number <= lastNum; number++) {
                paginationItemList.push(
                    <BsPagination.Item key={number} active={number === paginationActiveNumber} onClick={() => props.changePagination(number)}>
                        {number}
                    </BsPagination.Item>,
                );
            }
            return (
                <div className="ms-3 d-flex align-items-start">
                    <BsPagination className="p-0 m-0" size={props.size}>
                        {paginationItemList}
                    </BsPagination>
                </div>
            )
        }

        if (lastNum > 9) { // affichage simplifié si moins de 9 pages

            // précédent
            paginationItemList.push(<BsPagination.Prev key={'prev'} disabled={paginationActiveNumber == 1} onClick={() => props.changePagination(paginationActiveNumber - 1)} />);


            // premier numéro
            paginationItemList.push(
                <BsPagination.Item key={1} active={1 === paginationActiveNumber} onClick={() => props.changePagination(1)}>{1}</BsPagination.Item>
            );

            // ellipsis
            if (paginationActiveNumber > 3) {
                paginationItemList.push(<BsPagination.Ellipsis key={'ellipsis-prev'} disabled />);
            }

            // numéros avant le 6 (commence à 2)
            if (paginationActiveNumber < 4) {
                for (let number = 2; number <= 5; number++) {
                    paginationItemList.push(
                        <BsPagination.Item key={number} active={number === paginationActiveNumber} onClick={() => props.changePagination(number)}>
                            {number}
                        </BsPagination.Item>,
                    );
                }
            } else if (paginationActiveNumber >= 4 && paginationActiveNumber < lastNum - 2) {
                for (let number = paginationActiveNumber - 1; number < paginationActiveNumber + 2; number++) {
                    paginationItemList.push(
                        <BsPagination.Item key={number} active={number === paginationActiveNumber} onClick={() => props.changePagination(number)}>
                            {number}
                        </BsPagination.Item>,
                    );
                }
            } else if (paginationActiveNumber > lastNum - 3) {
                for (let number = lastNum - 4; number < lastNum; number++) {
                    paginationItemList.push(
                        <BsPagination.Item key={number} active={number === paginationActiveNumber} onClick={() => props.changePagination(number)}>
                            {number}
                        </BsPagination.Item>,
                    );
                }
            }


            // ellipsis
            if (paginationActiveNumber < lastNum - 2) {
                paginationItemList.push(<BsPagination.Ellipsis key={'ellipsis-next'} disabled />);
            }

            // dernier numéro
            paginationItemList.push(
                <BsPagination.Item key={lastNum} active={lastNum === paginationActiveNumber} onClick={() => props.changePagination(lastNum)}>{lastNum}</BsPagination.Item>
            );

            // suivant
            paginationItemList.push(<BsPagination.Next key={'next'} disabled={paginationActiveNumber >= (total / elementsPerPage)} onClick={() => props.changePagination(paginationActiveNumber + 1)} />);

            return (
                <div className="ms-3 d-flex align-items-start">
                    <BsPagination className="p-0 m-0" size={props.size}>
                        {paginationItemList}
                    </BsPagination>
                </div>
            )
        };

    }

    const PaginationItemsLimit = () => {
        return (
            <div className="ms-3 d-flex align-items-start">
                <Form.Select className="w-auto" size={props.size} defaultValue={props.elementsPerPage} onChange={e => props.changeLimit(e.target.value)} >
                    <option value="5">5 / page</option>
                    <option value="10">10 / page</option>
                    <option value="20">20 / page</option>
                    <option value="50">50 / page</option>
                    <option value="100">100 / page</option>
                    <option value="500">500 / page</option>
                </Form.Select>
            </div>
        )
    }

    const PaginationSetInputPageNumber = () => {

        const [pageNum, setPageNum] = useState(1)
        let lastNum = (total / elementsPerPage == Math.floor(total / elementsPerPage)) ? Math.floor(total / elementsPerPage) : Math.floor(total / elementsPerPage) + 1

        if (lastNum == 1) { // ne pas afficher si les résultats tiennent en 1 page
            return (null)
        }

        const onSubmitForm = (e) => {
            props.changePagination(pageNum)
            e.preventDefault()
        }

        const onPressKey = (e) => {
            if ((e.keyCode == 13) && (pageNum <= lastNum)) {
                props.changePagination(pageNum)
                e.preventDefault()
            }
        }

        return (
            <Form className="ms-3 d-flex align-items-start" onSubmit={onSubmitForm}>
                <InputGroup>
                    <Form.Control onKeyDown={onPressKey} name="pageNum" size={props.size} min="1" max={lastNum} placeholder="N° de page" onChange={e => setPageNum(parseInt(e.target.value))} className="input-page-number" /* value={natureAnalytiqueValue ?? ""} */ type="number" />
                    <Button type="submit" variant="secondary" size={props.size} disabled={pageNum > lastNum} /* onClick={() => props.changePagination(pageNum)} */>Go</Button>
                </InputGroup>
            </Form>

        )
    }


    return (
        <>
            {props.itemsLength > 0 &&
                <div id="pagination" className={"d-inline-flex " + (props.className ? props.className : "")}>
                    {/* {paginationComponent} */}

                    <PaginationPageNumbers />

                    {props.showDefinePage &&
                        <PaginationSetInputPageNumber />
                    }

                    {props.showChangeLimit &&
                        <PaginationItemsLimit />
                    }

                    <div className="d-flex align-items-start">
                        <small className={"align-self-center text-black-50 text-nowrap " + (((total / elementsPerPage > 1) || props.showChangeLimit || props.showDefinePage) ? "ms-3" : "")}>
                            {paginationActiveNumber * props.elementsPerPage - props.elementsPerPage + 1} — {(paginationActiveNumber * props.elementsPerPage) > props.itemsLength ? props.itemsLength : paginationActiveNumber * props.elementsPerPage} de {props.itemsLength} éléments
                        </small>
                    </div>


                </div>
            }
        </>
    )
}

export default Pagination;